/* eslint-disable prettier/prettier */
const validatePhoneNumber = () => {
  return /^[0-9]/;
};
export default validatePhoneNumber;
